import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { TITLES_IN_PRODUCTION } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';

@Component({
  selector: 'app-titles-in-production',
  templateUrl: './titles-in-production.component.html',
  styleUrls: ['./titles-in-production.component.css'],
})
export class TitlesInProductionComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  responseData: any = [];

  ngOnInit(): void {
    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = TITLES_IN_PRODUCTION) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
      });
  }

  createPostData() {
    return {
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      TITLES_IN_PRODUCTION,
      {
        is_download: 1,
        page: this.currentPage,
      },
      '',
      'titles_in_production'
    );
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }
}
